import { Outlet } from "react-router";

import { useMe } from "../api/session";
import { ErrorBlock, LoadingBlock } from "../components/States";
import { isNotLinkedError } from "../lib/api";
import { MeProvider } from "../lib/currentUser";
import { useTranslation } from "../lib/i18n";
import { NotLinkedPage } from "../pages/NotLinkedPage";
import { AppShell } from "./AppShell";

/**
 * Everything authenticated starts here: GET /api/me decides between the app shell, the
 * "account not linked" page (403 « non relié »), or an error to retry.
 */
export function RootLayout() {
  const { t } = useTranslation();
  const me = useMe();

  if (me.isPending) {
    return (
      <div className="ada-full-screen">
        <LoadingBlock label={t("Opening your session…")} />
      </div>
    );
  }
  if (me.isError) {
    if (isNotLinkedError(me.error)) return <NotLinkedPage onRetry={() => void me.refetch()} />;
    return (
      <div className="ada-full-screen">
        <ErrorBlock error={me.error} title={t("Could not open your session")} onRetry={() => void me.refetch()} />
      </div>
    );
  }
  return (
    <MeProvider me={me.data}>
      <AppShell>
        <Outlet />
      </AppShell>
    </MeProvider>
  );
}
